import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';

import Text from './PrototypeText';
import Document from './PrototypeDocument';
import Link from './PrototypeLink';
import Video from './PrototypeVideo';

class PrototypeResourceScroll extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className={`prototype-objects`}>
                <Text/>
                <Document/>
                <Link/>
                <Video/>
            </div>
        );
    }
}

PrototypeResourceScroll.propTypes = {
};

PrototypeResourceScroll.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeResourceScroll);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeResourceScroll.js
 **/